import React from 'react';

interface SvgIconProps {
  /** SVG 源代码字符串或导入的 SVG 文件 */
  src: string;
  /** 图标颜色 */
  color?: string;
  /** 图标大小 */
  size?: string | number;
  /** 额外的样式类 */
  className?: string;
  /** 额外的内联样式 */
  style?: React.CSSProperties;
  /** 其他属性 */
  [key: string]: any;
}

/**
 * SVG 图标组件 - 专门处理字符串类型的 SVG
 */
const SvgIcon: React.FC<SvgIconProps> = ({
  src,
  color = 'currentColor',
  size = '24px',
  className = '',
  style = {},
  ...rest
}) => {
  // 处理尺寸
  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  // 处理 SVG 字符串 - 添加颜色
  const getSvgWithColor = (svgString: string): string => {
    // 如果是 URL 而不是 SVG 字符串，直接使用 img 标签
    if (svgString.startsWith('data:') || svgString.startsWith('http') || svgString.startsWith('./') || svgString.startsWith('/')) {
      return '';
    }

    // 对于 SVG 字符串，替换颜色
    return svgString.replace('<svg', `<svg fill="${color}" stroke="${color}"`);
  };

  // 组合样式
  const containerStyle: React.CSSProperties = {
    display: 'inline-block',
    width: sizeValue,
    height: sizeValue,
    ...style
  };

  // 判断是否是 URL
  const isUrl = typeof src === 'string' && (
    src.startsWith('data:') || 
    src.startsWith('http') || 
    src.startsWith('./') || 
    src.startsWith('/')
  );

  if (isUrl) {
    // 如果是 URL，使用 img 标签
    return (
      <img 
        src={src}
        alt="Icon"
        className={className}
        style={containerStyle}
        {...rest}
      />
    );
  } else {
    // 如果是 SVG 字符串，使用 dangerouslySetInnerHTML
    const svgWithColor = getSvgWithColor(src);
    
    return (
      <div
        className={className}
        style={containerStyle}
        dangerouslySetInnerHTML={{ __html: svgWithColor }}
        {...rest}
      />
    );
  }
};

export default SvgIcon;